// Single config for swappable assets and links.
// Set purchaseLinksEnabled=true once English retailers are live.

export const book = {
  cover: {
    src: '/covers/cover-book.jpg',
    mockupSrc: '/covers/book-mockup.png',
    alt: 'The Wrath of a Requiem — book cover',
  },
  sample: {
    enabled: true,
    href: '/sample/requiem-sample.pdf',
    filename: 'requiem-sample.pdf',
  },
  retailers: [
    {
      id: 'pigi',
      label: 'Εκδόσεις Πηγή',
      labelEn: 'Pigi (Greek edition)',
      url: 'https://www.pigi.gr/product/vivlio-fantasias-h-orgi-enos-requiem-ekdoseis-pigi/',
      enabled: true,
      lang: 'gr',
    },
    {
      id: 'ianos',
      label: 'IANOS',
      url: 'https://www.ianos.gr/books/logotechnia/elliniki-logotechnia/i-orgi-enos-rekviem-0589280',
      enabled: true,
    },
    {
      id: 'politeia',
      label: 'Politeia',
      url: 'https://www.politeianet.gr/el/products/9789606268403-o-xoros-ton-besperse%CF%8Ad-h-orgh-enos-rekbiem-proto-biblio',
      enabled: true,
    },
    {
      id: 'protoporia',
      label: 'Protoporia',
      url: 'https://www.protoporia.gr/papadakis-aleksandros-i-orgi-enos-rekviem-o-xoros-ton-vesperseint-9789606268403.html',
      enabled: true,
    },
    {
      id: 'skroutz',
      label: 'Skroutz',
      url: 'https://www.skroutz.gr/s/63588445/i-orgi-enos-rekviem.html',
      enabled: true,
    },
  ],
  social: [
    {
      id: 'instagram',
      label: 'Instagram',
      url: 'https://www.instagram.com/wrath_of_a_requiem',
    },
    {
      id: 'facebook',
      label: 'Facebook',
      url: 'https://www.facebook.com/people/%CE%97-%CE%9F%CF%81%CE%B3%CE%AE-%CE%B5%CE%BD%CF%8C%CF%82-%CE%A1%CE%AD%CE%BA%CE%B2%CE%B9%CE%B5%CE%BC/61578735026093/',
    },
    {
      id: 'goodreads',
      label: 'Goodreads',
      url: 'https://www.goodreads.com/book/show/242419358',
    },
  ],
  contactEmail: 'author@wrathofarequiem.com',
  mailerLite: {
    accountId: '1636455',
    formAction:
      'https://assets.mailerlite.com/jsonp/1636455/forms/167870530656929452/subscribe',
    universalScript: 'https://assets.mailerlite.com/js/universal.js',
  },
  // Set when ready, e.g. '1234567890123456'. Pixel only fires after consent.
  metaPixelId: '',
};
